import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom"
import logo from "../../logo.svg"
import { setSearch } from "../../redux/features/filter/filterSlice";

export default function Header(){
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState("");

  // debounce functionality
  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(setSearch(inputValue));
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [dispatch, inputValue]);

  
  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };
  return(
    <nav className="container relative py-3">
    <div className="flex items-center justify-between">
      <Link to="/">
        <img src={logo} alt="lws Task Application"/>
      </Link>
      <div className="flex-1 max-w-xs search-field group">
        <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
        <input type="text" placeholder="Search Task" className="search-input" id="lws-searchTask" 
        value={inputValue}
        onChange={handleInputChange}
        />
      </div>
    </div>
  </nav>
  )};